import { fontSize } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';

const { spacing, fonts, text } = dggTheme;

export const container = css`
  background-color: var(--dgg-moody-blue);
`;

export const closeBtn = css`
  position: absolute;
  z-index: 2;
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  right: ${pxToRem(spacing.xxxl)};
  top: ${pxToRem(spacing.xxl)};
  background-color: var(--dgg-moody-blue);
  display: flex;
`;

export const iconContainer = css`
  margin: auto;
`;

export const navItemList = css`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
`;

export const navItem = css`
  margin: ${pxToRem(12)} 0;
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  ${fontSize(text.HEADING.MD)}

  a {
    color: var(--dgg-neutral-white);
    text-decoration: none;

    &:hover {
      color: var(--dgg-paris-m);
    }
  }
`;
